module.exports = __webpack_public_path__ + "static/aligners02-91a7c65039483a87114ddbdd5f665290.jpg";